import { render } from "./ProduitEnvoisExpress.vue?vue&type=template&id=c6daa6d4&scoped=true&ts=true"
import script from "./ProduitEnvoisExpress.vue?vue&type=script&lang=ts"
export * from "./ProduitEnvoisExpress.vue?vue&type=script&lang=ts"

import "./ProduitEnvoisExpress.vue?vue&type=style&index=0&id=c6daa6d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6daa6d4"]])

export default __exports__